import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatPercentage } from '../../../../../../../app/common/Percentage';
import { getOpenRatePercent } from '../../../../campaign-utils';
import styles from './styles.module.scss';
import { pluralize } from './utils';
import { shouldShowOpenRate } from '../utils';
export var buildOpenRateProps = function (campaign) { return ({
    shouldShow: shouldShowOpenRate(campaign),
    openRatePercent: getOpenRatePercent(campaign),
    openRateUsers: campaign.totalUniqueOpenRateCounter,
}); };
export var OpenRate = function (_a) {
    var shouldShow = _a.shouldShow, openRatePercent = _a.openRatePercent, openRateUsers = _a.openRateUsers;
    if (!shouldShow) {
        return null;
    }
    return (_jsxs("div", { className: styles.multiline, children: [_jsx("div", { className: styles.header, children: formatPercentage(openRatePercent, 2) }), _jsx("div", { className: styles.subheader, children: pluralize(openRateUsers, 'user') })] }));
};
